export function toFixed(val, precision) {
  return parseFloat(val.toFixed(precision));
}
